<template>
  <div
    class="onboarding-media fill-width"
    :class="{
      'fullscreen background-post-background': fullscreen,
      'd-flex justify-center align-center': !fullscreen
    }"
  >
    <div v-if="configuration.onboardingVideoUrl" class="position-relative">
      <video ref="video" autoplay muted loop playsinline>
        <source :src="configuration.onboardingVideoUrl" />
      </video>

      <the-button icon small custom-colors class="unmute-button" @click="toggleMute">
        <i-custom-volume-off v-if="isMuted" />
        <i-custom-volume-on v-else />
      </the-button>
    </div>
    <img v-else-if="onboardingImageUrl" :src="onboardingImageUrl" />
    <app-logo v-else :size="144" />

    <div v-if="fullscreen" class="buttons-container background-post-background">
      <the-button block class="ma-0" @click="$emit('close')">{{ $translate("OnboardingMedia.getStarted") }}</the-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia"
import { useConfigurationStore } from "@/store/configuration.js"

export default {
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMuted: true
    }
  },
  computed: {
    ...mapState(useConfigurationStore, ["configuration"]),
    onboardingImageUrl() {
      if (!this.configuration.onboardingImage?.length) {
        return null
      }

      const bestHeightFit = this.configuration.onboardingImage.find((image) => image.height > window.innerHeight)
      return bestHeightFit?.url || this.configuration.onboardingImage[this.configuration.onboardingImage.length - 1].url
    }
  },
  methods: {
    toggleMute() {
      if (!this.$refs.video) {
        return
      }

      this.isMuted = !this.isMuted
      this.$refs.video.muted = this.isMuted
    }
  }
}
</script>

<style lang="scss" scoped>
.onboarding-media {
  video,
  img {
    max-width: 412px;
    max-height: calc(100vh - 64px);
    border-radius: var(--rounded-app);
    object-fit: cover;
  }

  img {
    aspect-ratio: 477 / 848;
  }

  &.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100vw;
    height: 100vh;

    video,
    img {
      border-radius: 0;
      object-fit: cover;
      height: calc(100vh - 80px);
      min-width: 100vw;
    }

    .buttons-container {
      position: fixed;
      width: 100%;
      padding: 16px;
      bottom: 0;
      left: 0;

      .v-btn {
        height: 48px;
        font-size: var(--font-size-title-small);
      }
    }
  }
}

.unmute-button {
  position: absolute;
  top: 16px;
  right: 16px;
  color: var(--color-white);
}
</style>
